import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { ChevronLeftIcon } from '../icons';

export interface BackLinkProps {
  to: string;
  label: string;
  /** Rendered after the label in the accent colour, e.g. "Izlagači: Tehnologije". */
  suffix?: string;
  suffixClassName?: string;
}

export function BackLink({ to, label, suffix, suffixClassName }: BackLinkProps): ReactElement {
  return (
    <Link to={to} className="inline-flex items-center gap-1 py-2 text-primary">
      <ChevronLeftIcon className="size-4" />
      <span className="text-sm">
        {label}
        {suffix !== undefined && (
          <>
            {': '}
            <span className={suffixClassName ?? ''}>{suffix}</span>
          </>
        )}
      </span>
    </Link>
  );
}
